export default __webpack_public_path__ + "static/media/96.b91cca7a.jpg";